import { ScheduledFreeShippingThreshold } from '__generated__/graphql';
import { isDateBetween } from 'utils/dateCalculations';
import { isNotNullish } from 'utils/isNotNullish';

export const getScheduledFreeShippingThreshold = (scheduledFreeShipping?: {
  scheduledThresholds?: ScheduledFreeShippingThreshold[] | null | undefined;
  dateToCheck?: Date;
}): number | null => {
  const { scheduledThresholds, dateToCheck } = scheduledFreeShipping || {};

  if (!scheduledThresholds || !dateToCheck) {
    return null;
  }

  const activeScheduledThreshold = scheduledThresholds?.find(
    ({ threshold, availableFrom, availableTo }) => {
      return (
        isNotNullish(threshold) &&
        isNotNullish(availableFrom) &&
        isNotNullish(availableTo) &&
        isDateBetween({
          startDate: new Date(availableFrom),
          endDate: new Date(availableTo),
          dateToCheck,
        })
      );
    }
  );

  return activeScheduledThreshold?.threshold ?? null;
};
